import {Modal} from "theme"; // Import the theme web component

var KlaviyoBackInStock = class extends HTMLElement {
  constructor() {
    super();      
    this.form = this.querySelector('form');
    this.modal = this.querySelector('dialog');
    this.variantIdInput = this.querySelector('[name="variant_id"]');
    this.productTitleInput = this.querySelector('[name="product_title"]');
    this.variantTitleInput = this.querySelector('[name="variant_title"]');
    this.showModalButton = this.querySelector('button[type="button"]');
    this.featuredImage = this.querySelector('[name="featured_image"]');

    this.closeButton = this.querySelector('.close-dialog');    
    // Initial state check (e.g. on page load)
    this.updateVisibilityFromVariant(window.variant ||  { 
      id: this.variantIdInput.value, 
      name: this.productTitleInput.value, 
      available: this.dataset.available,
      featured_image: { src: this.featuredImage.value }
    });
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('variant:change', (event) => {
      this.updateVisibilityFromVariant(event.detail.variant);
    });
    this.showModalButton.addEventListener('click', () => {
      this.modal.classList.remove('submitted');
      this.modal.showModal();
    });
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await this.handleSubmit();
    });
    this.closeButton.addEventListener('click', (e) => {
      this.modal.close(); // click outside
    });

  }

  updateVisibilityFromVariant(variant) {
    if (!variant) return;
    this.dataset.available = variant.available;        
    this.variantIdInput.value = variant.id;
    this.productTitleInput.value = variant.name;
    if (variant.featured_image ) {      
      this.featuredImage.value = variant.featured_image.src;  
    }
  }

  async handleSubmit() {
    const email = this.form.querySelector('[name="email"]').value;
    const product_id = this.form.querySelector('[name="product_id"]').value;
    const restock_type = this.form.querySelector('[name="restock_type"]').value;
    const company_id = 'Sjshsj';    // AYM Klaviyo Company Id

    const variant_id = this.variantIdInput.value;
    const product_title = this.productTitleInput.value;
    const featured_image = this.featuredImage.value;    

    if (window.klaviyo && window.klaviyo.track) {  
      // Identify user (optional but recommended)
      window.klaviyo.identify({ email });

      const variantCompositeId = `$shopify:::$default:::${variant_id}`;
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                  // You can include other profile attrs if you have them (first_name, last_name, etc.)
                }
              }
            },
            channels: ['EMAIL'] // or ['EMAIL','SMS'] if you also collect SMS
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: variantCompositeId
              }
            }
          }
        }
      };

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(company_id)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-06-15' // required header per docs
            },
            body: JSON.stringify(payload)
          }
        );

        // Klaviyo returns 202 on success with no body
        if (!res.ok && res.status !== 202) {
          const err = await res.json().catch(() => ({}));
          console.warn('Klaviyo BIS subscribe failed', res.status, err);
        }
      
        console.log('Klaviyo identify and track called'); 
       } catch (e) {
        console.error('Network error calling Klaviyo BIS subscribe', e);
      }       
    }      
    this.modal.classList.add('submitted');
  }
};

customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);
  

var MarketWelcomePopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppendToBody() {
    return false;
  }
  get shouldAppearAutomatically() {
    const query_override = new URLSearchParams(window.location.search).has('market-popup')
    return !(this.hasAttribute("only-once") && localStorage.getItem("theme:market-popup-appeared") === "true") || query_override;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:market-popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("market-welcome-popup")) {
  window.customElements.define("market-welcome-popup", MarketWelcomePopup);
}